import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance3ftsl9x5arf2y as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instanceqqdki6i32scv as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance1r5xzfn2s7bx0 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      s6x(writer, customScalarAdapters, value) {
        writer.l4d('id');
        get_playerIdAdapter().q40(writer, customScalarAdapters, value.a6v_1);
        writer.l4d('name');
        get_StringAdapter().q40(writer, customScalarAdapters, value.b6v_1);
        writer.l4d('email');
        get_StringAdapter().q40(writer, customScalarAdapters, value.c6v_1);
        var tmp = value.d6v_1;
        if (tmp instanceof Present()) {
          writer.l4d('badge');
          present(nullable(Badge_ResponseAdapter_instance)).o41(writer, customScalarAdapters, value.d6v_1);
        }
        writer.l4d('callSignAdjective');
        get_StringAdapter().q40(writer, customScalarAdapters, value.e6v_1);
        writer.l4d('callSignNoun');
        get_StringAdapter().q40(writer, customScalarAdapters, value.f6v_1);
        var tmp_0 = value.g6v_1;
        if (tmp_0 instanceof Present()) {
          writer.l4d('imageURL');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.g6v_1);
        }
        var tmp_1 = value.h6v_1;
        if (tmp_1 instanceof Present()) {
          writer.l4d('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).o41(writer, customScalarAdapters, value.h6v_1);
        }
        writer.l4d('unvalidatedEmails');
        list(get_StringAdapter()).m41(writer, customScalarAdapters, value.i6v_1);
        writer.l4d('pins');
        list(obj(PinInput_InputAdapter_instance)).m41(writer, customScalarAdapters, value.j6v_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.s6x(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instance25ndfd53w8tvw,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
